<template>
  <div>
    <div
      class="instruction_title text-left para-mrgn-20"
      v-translate:dynamic_string="{
        key: `${translationKeyInitial}_formattedBody`,
        val: lang,
        html: question.formattedBody
      }"
      v-html="question.formattedBody"
    />
    <div>
      <b-form-select class="drop-down" @click.once="$emit('onClick', question)" v-model="question.answer" :disabled="isFieldDisabled">
        <!-- <option key value>&nbsp;</option> -->
        <option
          v-for="choice in componentData.options"
          :key="choice.id"
          :value="choice.id"
          v-html="choice.label"
          v-translate:dynamic_string="{
            key: widget.getDynamicStringKey(translationKeyInitial, choice),
            val: lang,
            optionId: choice.id,
            html: choice.label
          }"
          @change="onAnswerChange"
        ></option>
      </b-form-select>
    </div>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";
import { Widget } from "@/components/services/participant-service";
export default {
  name: "drop-down",
  mixins: [langTranslate],
  data() {
    return {
      widget: new Widget(),
      hasFieldError: false,
      fieldErrorText: "",
      scoresMap: {}
    };
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  mounted() {
    this.insertOtherOption();
    this.$root.$on("questionSkipped", (notifyObj) => {
      if(!!notifyObj && notifyObj.identifier === this.question.identifier && notifyObj.skipped){
        this.clearAnswer();
      }
    });
  },
  computed: {
    componentData() {
      return this.question.constraints;
    }
  },
  methods: {
    onAnswerChange(e) {
      this.$nextTick(() => {
        this.onChangeOptions(e);
        this.$emit("onAnswerChange", this.question);
      });
    },
    onChangeOptions(e) {
      this.componentData.computedScore = this.scoresMap[e];
      this.componentData.actualScore = this.scoresMap[e];
    },
    insertOtherOption() {
      if (this.componentData.otherOptionId) {
        const sequence = this.question.options.length + 1;
        this.componentData.options.push({
          body: this.componentData.otherOptionContentField,
          colorCoding: {
            color: "#fff",
            warningMessage: null
          },
          enabled: true,
          excludeScore: false,
          formattedBody: this.componentData.otherOptionContentField,
          id: this.componentData.otherOptionId,
          isAdvancedScoring: false,
          priority: 0,
          sendNotification: false,
          sequence: sequence
        });
      }
    },
    clearAnswer(){
      this.question.answer = undefined;
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.drop-down {
  padding: 0px;
}
</style>
